import { getBackgroundJobs } from "../../../BackgroundJobs/pages/_redux/BgJobsCrud";
import * as requestFromServer from "./dashboardCrud";
import { dashboardSlice, callTypes } from "./dashboardSlice";

const { actions } = dashboardSlice;

//request api for dashboard and save in redux
export const fetchDashboardStats = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .getDashboardStats(queryParams)
    .then((response) => {
      const { totalCount, entities } = response.data;
      dispatch(actions.dashboardStatsFetched({ totalCount, entities }));
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

//request api for Notifications and save in redux
export const fetchNotifications = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .getNotifications(queryParams)
    .then((response) => {
      const { totalCount, entities } = response.data;
      dispatch(actions.notificationsFetched({ totalCount, entities }));
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

//request api for Update Notifications and save in redux
export const updatedNotifications = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateNotifications(queryParams)
    .then((response) => {
      const { totalCount, message, entity } = response.data;
      dispatch(actions.updateNotifications({ totalCount, message, entity }));
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};
export const updatedAllNotifications = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .readAllNotifications(queryParams)
    .then((response) => {
     dispatch(fetchNotifications({page_size: 51}))
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const setNotification = (data) => (dispatch) => {
  dispatch(actions.notificationSet({ data }));
};

export const setBackgorundJobs = (data) => (dispatch) => {
  dispatch(actions.setBackgorundJobs({ data }));
};

export const fetchJobNotificationList = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return getBackgroundJobs(queryParams)
    .then((response) => {
      const { totalCount, entities } = response.data;
      dispatch(actions.fetchJobNotificationList({ entities }));
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};
